var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator-instance",class:_vm.colorScheme},[(_vm.title)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('calculator')],1)}
var staticRenderFns = []

export { render, staticRenderFns }